<!--
 * @Autor: liuzilei3
 * @Email: liuzilei3@jd.com
 * @Description: 
 * @CreateDate: Do not edit
 * @LastEditors: liuzilei3
-->
<template>
  <div :class="ns.b('option-img-label')">
    <jd-avatar
      v-if="src || icon"
      :size="props.size || 'mini'"
      v-bind="omitPropsSize"
    />
    <span><slot /></span>
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { omit } from 'lodash-unified'
import { useNamespace } from '@jdesign-vue/hooks'
import JdAvatar, { avatarProps } from '@jdesign-vue/components/avatar'

defineOptions({
  name: 'JdOptionImgLabel',
})

const props = defineProps(avatarProps)

// 移除 props 中的 size 属性
const omitPropsSize = computed(() => omit(props, 'size'))

const ns = useNamespace('select-dropdown')
</script>
